<template>

    <v-card :loading="loading">
        <v-tabs color="primary" fixed-tabs v-model="tab">
            <v-tab v-for="tab of tabs" :value="tab.label">
                <v-icon :icon="tab.icon"></v-icon>
                {{ tab.label }}</v-tab>
        </v-tabs>
        <v-card-text>
            <v-tabs-window v-model="tab">

                <v-tabs-window-item value="Info">
                    <v-container>
                        <v-row>
                            <v-col v-for="item in dashboard_items" :key="item.target" cols="6">
                                <slot name="owner"></slot>
                                <v-card>
                                    <v-card-title class="text-left font-weight-bold">
                                        {{ item.label }}
                                    </v-card-title>
                                    <v-card-text class="text-left text-body-1">
                                        {{ item.target === 'owner' ? ownerName : getItemContent(item) }}
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tabs-window-item>
                <v-tabs-window-item value="Vehicles">

                    <v-btn class="mb-3" width="100%" prepend-icon="mdi-plus-thick" color="primary"
                        :disabled="!user_perms.find(e => e.name == 'edit_mission') && !full_access"
                        @click="dialogAddVehicle = true">
                        Add vehicle
                    </v-btn>

                    <v-data-table-server :hide-default-footer="true" :loading="loading" :items="vehicles || []"
                        :items-length="vehicles.length" :headers="headers" @update:options="loadVehicles">
                        <template v-slot:item.icon="{ item }">
                            <Icon :icon="item.icon" :height="50" :rotate="0" :width="50" :color="item.boat_mark_color">
                            </Icon>

                        </template>
                        <template v-slot:item.name="{ item }">
                            <v-btn color="primary" variant="text" :to="'/admin/vehicle/' + item.id">
                                <strong>{{ item.name }}</strong>
                            </v-btn>
                        </template>
                        <template v-slot:item.records="{ item }">
                            <v-container class="d-flex justify-center align-center">
                                <v-col>
                                    <v-btn prepend-icon="mdi-file-download"
                                        :disabled="!user_perms.find(e => e.name == 'edit_mission') && !full_access"
                                        color="primary" variant="text" text="Export"
                                        @click="vehicleToUpdate = item; dialogDownloadCSV = true;">
                                    </v-btn>
                                    <v-btn prepend-icon="mdi-file-upload"
                                        :disabled="!user_perms.find(e => e.name == 'edit_mission') && !full_access"
                                        color="primary" variant="text" text="Import"
                                        @click="vehicleToUpdate = item; dialogUploadCSV = true;">
                                    </v-btn>
                                </v-col>
                            </v-container>
                        </template>
                        <template v-slot:item.waypoints="{ item }">
                            <v-container>
                                <v-col>
                                    <v-btn prepend-icon="mdi-map-marker"
                                        :disabled="!user_perms.find(e => e.name == 'edit_mission') && !full_access"
                                        color="primary" variant="text" text="Export" @click="exportWaypoints(item)">
                                    </v-btn>
                                    <v-btn prepend-icon="mdi-map-marker"
                                        :disabled="!user_perms.find(e => e.name == 'edit_mission') && !full_access"
                                        color="primary" variant="text" text="Import"
                                        @click="vehicleToUpdate = item; dialogUploadWaypoints = true;">
                                    </v-btn>
                                </v-col>
                            </v-container>
                        </template>
                        <template v-slot:item.delete="{ item }">
                            <v-container>
                                <v-col>
                                    <v-btn :disabled="!user_perms.find(e => e.name == 'delete_mission') && !full_access"
                                        prepend-icon="mdi-delete" color="error" variant="text" text="Remove vehicle"
                                        @click="vehicleToDelete = item; dialogDeleteVehicle = true">
                                    </v-btn>
                                </v-col>
                            </v-container>
                        </template>






                    </v-data-table-server>
                </v-tabs-window-item>
                <v-tabs-window-item value="Permissions">
                    <PermissionsTable :missionId="mission.id" :missionOwner="mission.owner"
                        :isPublic="mission.is_public === 1" @modified="modified_permissions = $event" />
                </v-tabs-window-item>

            </v-tabs-window>

        </v-card-text>
    </v-card>

    <v-overlay v-model="dialogAddVehicle" location="top" style="justify-content:center;align-items: center;">
        <AddMissionVehicle :mission="mission" @close="dialogAddVehicle = false" />
    </v-overlay>

    <v-overlay v-model="dialogDeleteVehicle" location="top" style="justify-content:center;align-items: center;">
        <ConfirmForm type-to-delete="vehicle"
            :text="'Are you sure you wanna delete vehicle ' + vehicleToDelete.name + ' from this mission?'"
            @close="dialogDeleteVehicle = false" @confirm="deleteVehicle(vehicleToDelete)" />
    </v-overlay>

    <v-overlay v-model="dialogUploadCSV" location="top" style="justify-content:center;align-items: center;">
        <ImportCSV :mission="mission" :vehicle="vehicleToUpdate" @close="dialogUploadCSV = false" />
    </v-overlay>

    <v-overlay v-model="dialogDownloadCSV" location="top" style="justify-content:center;align-items: center;">
        <ExportCSV :mission="mission" :vehicle="vehicleToUpdate" @close="dialogDownloadCSV = false" />
    </v-overlay>

    <v-overlay v-model="dialogUploadWaypoints" location="top" style="justify-content:center;align-items: center;">
        <ImportWaypoints :mission="mission" :vehicle="vehicleToUpdate" @close="dialogUploadWaypoints = false" />
    </v-overlay>


</template>
<script setup>
import PermissionsTable from './PermissionsTable'
import { useUserStore } from '@/store/userStore';
import { ref, computed, watchEffect } from 'vue';
import { useVehicleStore } from '@/store/vehicleStore';
import { storeToRefs } from 'pinia';
import { useMissionStore } from '@/store/missionStore';
import AddMissionVehicle from '../forms/AddMissionVehicle.vue';
import ConfirmForm from '../forms/ConfirmForm.vue';
import ExportCSV from './ExportCSV.vue';
import ImportCSV from './ImportCSV.vue';
import Icon from '@/components/icons/Icon.vue';
import { useNotificationStore } from '@/store/notificationStore';
import ImportWaypoints from './ImportWaypoints.vue';

const vehicleStore = useVehicleStore();
const missionStore = useMissionStore();
const { vehicles } = storeToRefs(vehicleStore);
const userStore = useUserStore();
const dialogAddVehicle = ref(false);
const dialogUploadCSV = ref(false);
const dialogDownloadCSV = ref(false);
const dialogUploadWaypoints = ref(false);
const dialogDeleteVehicle = ref(false);
const vehicleToDelete = ref();
const vehicleToUpdate = ref();
const loading = ref(false);
const { ownerMission } = storeToRefs(userStore);
const tab = ref();
const tabs = [{ label: "Info", icon: "mdi-information" },
{ label: "Vehicles", icon: "mdi-sail-boat" },
{ label: "Permissions", icon: "mdi-key" }];
const props = defineProps({
    mission: Object,
    user_perms: Object,
    full_access: Boolean
});


const headers = computed(() => [
    { title: 'Icon', align: 'center', sortable: false, key: 'icon' },
    { title: 'Vehicle', align: 'center', sortable: false, key: 'name' },
    { title: 'Records', align: 'center', sortable: false, key: 'records' },
    { title: 'Waypoints', align: 'center', sortable: false, key: 'waypoints' },
    { title: 'Delete', align: 'center', sortable: false, key: 'delete' },
]);

const loadVehicles = async () => {
    loading.value = true;
    await vehicleStore.fetchVehiclesOfMission(props.mission.id);
    loading.value = false;
}

watchEffect((mission) => {
    if (props.mission) {
        loadVehicles();
        userStore.getOwneer(props.mission.owner);
    }
});

const exportWaypoints = async (vehicle) => {
    loading.value = true;
    const waypoints = await vehicleStore.exportWaypoints(props.mission.id, vehicle.id);
    if (waypoints.length == 0) {
        useNotificationStore().setNotification("No waypoints available", "This vehicle does not have waypoints for this mission", "mdi-alert", "red")
    } else {
        const formattedWaypoints = waypoints.map(data => convertWaypointData(data));
        downloadJSON(formattedWaypoints, `Waypoints_${props.mission.name}_${vehicle.name}`);
    }
    loading.value = false;
}

function downloadJSON(data, filename) {
    const jsonStr = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonStr], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();

    URL.revokeObjectURL(url);
}




const dashboard_items = [
    {
        label: 'Name',
        target: 'name'
    },
    {
        label: 'Location',
        target: 'location'
    },
    {
        label: 'Start Date',
        target: 'start_date'
    },
    {
        label: 'End Date',
        target: 'end_date'
    },
    {
        label: 'Description',
        target: 'description'
    },
    {
        label: "The mission is public",
        target: "is_public"
    },
    {
        label: "The mission is active",
        target: "active_mission"
    },
    {
        label: "Owner",
        target: "owner"
    }
]

const getItemContent = (item) => {
    if (['start_date', 'end_date'].includes(item.target)) {
        return getFormattedDate(props.mission[item.target]);
    }
    if (['is_public', 'active_mission'].includes(item.target)) {
        return props.mission[item.target] === 1 ? "Yes" : "No";
    }
    return props.mission[item.target] || "N/A";
};


const ownerName = computed(() => {
    return ownerMission.value ? ownerMission.value.name : "Loading...";
});

const deleteVehicle = async (vehicle) => {
    loading.value = true;
    await vehicleStore.designVehicle(vehicle.id, props.mission.id);
    dialogDeleteVehicle.value = false;
    loading.value = false;
}

const convertWaypointData = (data) => {
    return {
        ...data,
        nodes: JSON.parse(data.nodes),
        latitudes: JSON.parse(data.latitudes),
        longitudes: JSON.parse(data.longitudes)
    };
}



const addZeroIfLessThanTen = (number = 0) => {
    return number < 10 ? "0" + number : number;
}

const getFormattedDate = (date) => {
    if (date === undefined || date === 0 || date === null) return "--------"
    return new Date(date).toLocaleString();
}


</script>
